import { useDispatch, useSelector } from "react-redux";
import { Dialog } from "@headlessui/react";
import { setShowRedirectionModal } from "../../redux/addOnSlice";
import {
  selectPowerminuteQuizStarted,
  selectQuizTimer,
} from "../../redux/powerminuteSlice";

const ExitModal = ({ showRedirectionModal, backModalOptions }) => {
  const dispatch = useDispatch();
  const quizTimer = useSelector(selectQuizTimer);
  const powerminuteQuizStarted = useSelector(selectPowerminuteQuizStarted);

  const handleModal = () => {
    dispatch(setShowRedirectionModal(false));
  };

  return (
    <div>
      <Dialog
        open={showRedirectionModal}
        onClose={handleModal}
        as="div"
        className="fixed z-50 inset-0 flex flex-col mx-auto text-white">
        <Dialog.Overlay className="fixed inset-0 mx-auto z-[60] bg-black opacity-80" />
        <Dialog.Title />
        <Dialog.Description />
        <div
          className="p-px m-auto max-w-lg w-[90%] z-[80] rounded-3xl"
          style={{
            backgroundImage:
              "linear-gradient(to bottom, rgba(213, 237, 255, 0.4) 0%, rgba(128, 142, 153, 0) 100%)",
          }}>
          <div
            className="bg-[#0D2436] px-6 pt-6 pb-8 rounded-3xl relative"
            style={{
              backgroundImage:
                "radial-gradient(circle at center, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)",
            }}>
            {!powerminuteQuizStarted ? (
              <>
                <img
                  src="https://ik.imagekit.io/238r9emirjj/main-quiz/emojis.com%20man-running-in-office-suit-with-case-in-hand-%201.png?updatedAt=1748417256470"
                  width={102}
                  height={102}
                  className="mx-auto"
                  alt=""
                />
                <div
                  className="cursor-pointer absolute top-5 right-5 bg-[#D9D9D9]/10 rounded-[10px] p-1"
                  onClick={handleModal}>
                  <img
                    src="https://ik.imagekit.io/238r9emirjj/main-quiz/X.svg?updatedAt=1748341279956"
                    width={24}
                    height={24}
                    alt=""
                  />
                </div>
                <h2 className="leading-[110%] mt-2 font-semibold text-xl text-center">
                  Looking for something?
                </h2>
                <p className="leading-[120%] text-[#D5EDFF]/60 text-xs font-medium mt-2 text-center">
                  ⚠ You Will Lose Test Progress if you go back
                </p>
              </>
            ) : (
              <>
                <div className="flex items-center justify-center z-50">
                  <div className="relative flex flex-col items-center">
                    <div className="relative w-full max-w-[225px] mx-auto h-[144px] flex flex-row items-center justify-center">
                      {/* Background decorative arrow */}
                      <div className="flex flex-col absolute left-0 z-10 bottom-6">
                        <div className="top-6 left-6 opacity-40 mb-4 w-10 h-10">
                          <img
                            src={
                              "https://ik.imagekit.io/238r9emirjj/PowerMinute/Union.svg?updatedAt=1751961239006"
                            }
                            alt="Arrow decoration"
                          />
                        </div>
                        <div className="top-12 left-12 w-10 h-10">
                          <img
                            src={
                              "https://ik.imagekit.io/238r9emirjj/PowerMinute/Union.svg?updatedAt=1751961239006"
                            }
                            alt="Arrow decoration"
                          />
                        </div>
                      </div>

                      {/* Certificate */}
                      <div className="relative flex justify-center">
                        <img
                          src={
                            "https://ik.imagekit.io/238r9emirjj/PowerMinute/SkillCertificate.svg?updatedAt=1751961240317"
                          }
                          alt="Certificate of Completion"
                          className="w-44 max-w-[175px] mx-auto h-32 shadow-lg"
                        />
                      </div>

                      {/* Timer */}
                      <div>
                        <div className="absolute w-[84px] h-[71px] right-0 bottom-0 bg-[url(https://ik.imagekit.io/238r9emirjj/PowerMinute/quizzes-timer.png?updatedAt=1748857996668)] bg-[100%_100%]">
                          <img
                            src="https://ik.imagekit.io/238r9emirjj/PowerMinute/Union.svg?updatedAt=1751961239006"
                            alt="Arrow decoration"
                            className="absolute -top-10 z-0 right-0"
                          />
                          <div className="absolute w-[62px] h-[62px] top-1 left-2.5 rounded-[42px]">
                            <div
                              className={`absolute w-[62px] h-[62px] top-0 left-0 rounded-[42px] overflow-hidden border-[3px] border-solid ${
                                quizTimer <= 10
                                  ? "border-[#533E1F] bg-[#533E1F]"
                                  : quizTimer <= 30
                                  ? "border-[#4A521F] bg-[#4A521F]"
                                  : "border-[#002e4e] bg-[#1f3a53]"
                              }`}>
                              <div className="absolute w-14 h-14 bg-[url(https://ik.imagekit.io/238r9emirjj/PowerMinute/quiz-eclipse-white.svg?updatedAt=1748857947686)] bg-[100%_100%]">
                                <img
                                  className="w-14 h-14 absolute top-0 left-0"
                                  alt="Ellipse"
                                  src={`${
                                    quizTimer <= 10
                                      ? "https://ik.imagekit.io/238r9emirjj/PowerMinute/ellipse-orange.png?updatedAt=1748945313742"
                                      : quizTimer <= 30
                                      ? "https://ik.imagekit.io/238r9emirjj/PowerMinute/ellipse-yellow.png?updatedAt=1749719151031"
                                      : "https://ik.imagekit.io/238r9emirjj/PowerMinute/quiz-timer.svg?updatedAt=1748857893582"
                                  }`}
                                />
                                <div
                                  className={`absolute top-4 left-4 text-center justify-center opacity-80 font-rajdhani font-bold ${
                                    quizTimer <= 10
                                      ? "text-[#FFBE55]"
                                      : quizTimer <= 30
                                      ? "text-[#FFFC61]"
                                      : "text-[#80ffcd]"
                                  } text-2xl leading-[14.4px] whitespace-nowrap text-center tracking-[0] ${
                                    quizTimer < 10 ? "ml-1.5" : ""
                                  }`}>
                                  {quizTimer}
                                </div>
                              </div>
                            </div>
                            <img
                              className="absolute w-3 h-3 top-[38px] left-[25px] object-cover"
                              alt="Rapid fire"
                              src="https://ik.imagekit.io/238r9emirjj/PowerMinute/rapid-fire.png?updatedAt=1748445006087"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Main text */}
                    <div className="text-center mb-6">
                      <h2 className="text-white text-xl font-semibold mb-2">
                        <span className="text-[#81C243]">
                          00<span className="blink">:</span>
                          {quizTimer < 10 ? "0" : ""}
                          {quizTimer}s
                        </span>{" "}
                        To Improve Certificate
                      </h2>
                      <p className="text-gray-400 text-sm">
                        Answer Maximum Questions To Test More Topics
                        <br />& Improve Your Score.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex justify-center items-center mb-6">
                  <span className="px-4 text-gray-400 text-sm">OR</span>
                </div>
              </>
            )}
            <div
              className="cursor-pointer absolute top-5 right-5 bg-[#D9D9D9]/10 rounded-[10px]"
              onClick={handleModal}>
              <img
                src="https://ik.imagekit.io/238r9emirjj/PowerMinute/cross.svg?updatedAt=1751964155433"
                width={32}
                height={32}
                alt="close icon"
              />
            </div>

            <div
              className={`flex flex-col gap-4 ${
                !powerminuteQuizStarted ? "mt-8" : ""
              }`}>
              {backModalOptions?.map((item, index) => (
                <div
                  key={index}
                  className="p-px rounded-lg"
                  style={{
                    backgroundImage:
                      "linear-gradient(to bottom, rgba(213, 237, 255, 0.2) 0%, rgba(128, 142, 153, 0) 100%)",
                  }}
                  onClick={item?.onClick}>
                  <div className="bg-[#FFFFFF]/5 px-3 py-4 text-[#D5EDFF] font-semibold leading-[120%] rounded-lg text-center">
                    <p>
                      {item?.title}
                      <span className="text-[11px] text-[#D5EDFF]/60 ml-2">
                        ⚠
                      </span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
            {powerminuteQuizStarted && (
              <p className="leading-[120%] font-sans text-[#D5EDFF]/60 text-xs font-medium mt-4 text-center">
                ⚠ You Will Lose Test Progress if you go back
              </p>
            )}
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ExitModal;
